<template>
  <button @click="$router.back()" title="Voltar" class="floating-button">
    <i class="fa-solid fa-arrow-left"></i>
  </button>
</template>

<script>
export default {
  name: 'FloatBackPage'
}
</script>

<style lang="scss" scoped>
.floating-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #b3a185;
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  i {
    color: #fff;
    font-size: 30px;
  }

  &:hover {
    // background-image: linear-gradient(to right ,#1e7c84, #1accdd);
    // transform: translateY(-5px);
    transform: scale(1.1);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  }

  &:focus {
    // box-shadow: 0px 0px 0px 2px rgba(11, 112, 54, 0.5);
    outline: none;
    transform: scale(0.95);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.95);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}
</style>
